/**
 * 单据字段配置
 * 1、LIST_FIELD_CONFIG      单据列表字段配置
 * 2、DETAIL_FIELD_CONFIG    单据详情字段配置
 */
export const LIST_FIELD_CONFIG: any = {
  10: [
    [
      { component: 'batch', width: '3%', align: 'center', disabled: true },
      {
        component: 'vReadStatus',
        width: '3%',
        align: 'center',
        notDisplayLabel: 'BASE.ALREADY_READ'
      }
    ],
    [
      { component: 'innerVendorName', label: 'BASE.VENDOR', width: '11%' },
      { component: 'innerVendorCode', label: 'BASE.INNER_VENDOR_CODE' },
      { component: 'companyName', label: 'BASE.PURCHASER' }
    ],
    [
      { component: 'poErpNo', label: 'BASE.PO_NUM', width: '10%' },
      { component: 'fileCount', label: 'BASE.ORDER_ATTACHMENT' }
    ],
    [
      { component: 'erpPurchaseDate', label: 'PO.PURCHASE_DATE', width: '8%' },
      { component: 'updateTime', label: 'BASE.REPLY_DATE' }
    ],
    [
      { component: 'buyerName', label: 'BASE.BUYER', width: '5%' },
      { component: 'purDepartmentName', label: 'BASE.PURCHASE_DEPARTMENT' },
      { component: 'erpOrgCode', label: 'BASE.PURCHASE_ORG_CODE' },
      { component: 'erpOrgName', label: 'BASE.PURCHASE_ORG_NAME' }
    ],
    [
      { component: 'remark', label: 'BASE.ORDER_REMARK', width: '9%' },
      { component: 'purchaseType', label: 'BASE.PURCHASE_TYPE' },
      { component: 'wbsProjectName', label: 'PR.PR_PROJECT' },
      { component: 'isAdvanceOrder', label: 'BASE.ADVANCEORDER' }
    ],
    [{ component: 'extendFields', label: 'BASE.EXTENDED_FIELD', width: '8%' }],
    [
      { component: 'productTotal', label: 'BASE.ORDER_AMOUNT', width: '10%' },
      { component: 'vProductTotal', label: 'BASE.REPLY_AMOUNT' }
    ],
    [
      {
        component: 'diffReasonNameShow',
        label: 'BASE.DIFF_REASON',
        width: '8%'
      },
      { component: 'vendorAttachCount', label: 'BASE.INNER_VENDOR_ATTACHMENT' }
    ],
    [
      { component: 'orderStatus', label: 'BASE.ORDER_STATUS', width: '8%' },
      { component: 'syncStatus', label: 'BUTTON.SYNC_ERP' },
      { component: 'ontimeAnswerTime', label: 'PO.DEADLINE_ON_TIME' },
      { component: 'payStatus', label: 'BASE.PAYMENT_ORDER_STATUS' }
    ],
    [
      { component: 'receiveStatus', label: 'BASE.RECEIVE_STATUS', width: '8%' },
      { component: 'esignStatus', label: 'BASE.E-SIGN_STATUS' },
      { component: 'wfStatus2', label: 'BASE.APPROVAL_STATUS' },
      { component: 'wfCurrNode', label: 'WORKFLOW.CURR_APPROVAL_STEP' }
    ],
    [
      {
        component: 'actions',
        label: 'BASE.ACTIONS',
        width: '8%',
        disabled: true
      }
    ]
  ],
  22: [
    [
      {
        component: 'innerVendorName',
        label: 'BASE.INNER_VENDOR_NAME',
        width: '15%'
      },
      { component: 'innerVendorCode', label: 'BASE.INNER_VENDOR_CODE' }
    ],
    [
      { component: 'dnXkNo', label: 'BASE.DN_NUM', width: '10%' },
      { component: 'purchaseType', label: 'BASE.PURCHASE_TYPE' },
      { component: 'poErpNoShow', label: 'BASE.PO_NUM' }
    ],
    [
      { component: 'deliveryDate', label: 'BASE.DELIVERY_DATE', width: '10%' },
      { component: 'extendN01', label: '自定义字段1' },
      { component: 'extendN02', label: '自定义字段2' },
      { component: 'extendN03', label: '自定义字段3' }
    ],
    [
      {
        component: 'profitCenterName',
        label: 'BASE.RECEIVING_DEPARTMENT',
        width: '10%'
      },
      { component: 'receiveAreaName', label: 'DELIVERY.RECEIVE_STORE' },
      { component: 'planArrivedDate', label: 'BASE.EST_ARRIVE' }
    ],
    [
      { component: 'deliveryType', label: 'BASE.DELIVERY_TYPE', width: '8%' },
      { component: 'logisticsTypeShow', label: 'BASE.DELIVERY_WAY' },
      { component: 'logisticsNumber', label: 'BASE.LOGISTICS_NUM' }
    ],
    [
      { component: 'status', label: 'BASE.STATUS', width: '8%' },
      { component: 'printStatus', label: 'BASE.PRINT_STATUS' },
      { component: 'vendorAttachCount', label: 'BASE.INNER_VENDOR_ATTACHMENT' }
    ],
    [
      {
        component: 'logisticsStatus',
        label: 'BASE.LOGISTICS_STATUS',
        width: '9%'
      },
      { component: 'cargoDeliveryTime', label: 'BASE.ARRIVE_TIME' }
    ],
    [
      { component: 'firstCheck', label: 'DELIVERY.IQC_FIRST', width: '7%' },
      { component: 'isSignForSupplier', label: 'BASE.ON_BEHALF_OF' }
    ],
    [
      {
        component: 'sendVerifyStatus',
        label: 'BASE.VERIFY_STATUS',
        width: '7%'
      },
      { component: 'iqcResult', label: 'BASE.RESULT_DESC' },
      { component: 'iqcDetail', label: 'BASE.IQC_ORDER' }
    ],
    [{ component: 'diffStatus', label: 'DELIVERY.SIGNING_DIFF', width: '8%' }],
    [
      {
        component: 'actions',
        label: 'BASE.ACTIONS',
        width: '8%',
        disabled: true
      }
    ]
  ],
  29: [
    [
      { component: 'companyName', label: 'BASE.COMPANY_NAME', width: '15%' },
      {
        component: 'innerVendorCode',
        label: 'BASE.INNER_VENDOR_CODE',
        width: '15%'
      }, //供应商编码
      {
        component: 'innerVendorName',
        label: 'BASE.INNER_VENDOR_NAME'
      } //供应商名称
    ],
    [
      {
        component: 'innerVendorAbbr',
        label: 'BASE.INNER_VENDOR_ABBR',
        width: '10%'
      }, //供应商简称
      {
        component: 'lifeCycleName',
        label: 'BASE.LIFE_CYCLE'
      } //生命周期
    ],
    [
      {
        component: 'vendorCode',
        label: 'BASE.COMPANY_CODE',
        width: '15%'
      }, //携客企业号
      {
        component: 'vendorName',
        label: 'BASE.BIND_COMPANY_NAME'
      } //绑定企业名称
    ],
    [
      {
        component: 'vendorCategoryName',
        label: 'BASE.CATEGORY_ERP',
        width: '10%'
      }, //ERP分类
      {
        component: 'businessForm',
        label: 'BASE.BUSINESS_FORM'
      }, //经营形态
      {
        component: 'accessCategoryName',
        label: 'BASE.ACCESS_CATEGORY_1'
      } //准入分类
    ],
    [
      {
        component: 'categoryName01',
        label: 'ENUM.CATEGORY_1',
        width: '10%'
      }, //分类1
      {
        component: 'categoryName02',
        label: 'ENUM.CATEGORY_2'
      }, //分类2
      {
        component: 'categoryName03',
        label: 'ENUM.CATEGORY_3'
      }, //分类3
      {
        component: 'performanceClassificationName',
        label: 'ENUM.CATEGORY_4'
      } //绩效分类
    ],
    [
      {
        component: 'handshakeTime',
        label: 'BASE.HANDSHAKE_TIME',
        width: '10%'
      }, //加入日期
      {
        component: 'inviteName',
        label: 'BASE.INVITE_BY'
      } //邀约人
    ],
    [
      {
        component: 'inviteStatus',
        label: 'BASE.INVITE_STATUS_NAME',
        width: '10%'
      }, //邀约状态
      {
        component: 'vendorStatus',
        label: 'BASE.VENDOR_STATUS'
      } //供应商状态
    ],
    [
      {
        component: 'commonSealUploadFlag',
        label: 'BASE.OFFICIAL_SEAL_UPLOAD',
        width: '10%'
      }, //公章上传
      {
        component: 'validTime',
        label: 'BASE.VALID_TYPE_NAME'
      } //有效期
    ],
    [
      {
        component: 'esignFlag',
        label: 'BASE.E-SIGN',
        width: '10%'
      }, //电子签章
      {
        component: 'esignAuthStatus',
        label: 'BASE.E-SIGN_AUTH_STATUS'
      } //签章认证
    ]
  ],
  51: [
    [
      {
        component: 'erpOrgCode',
        label: 'BASE.PURCHASE_ORG_CODE',
        width: '10%'
      }, //采购组织编码
      { component: 'erpOrgName', label: 'BASE.PURCHASE_ORG_NAME' } //采购组织名称
    ],
    [
      { component: 'inqXkNo', label: 'BASE.INQUIRY_NUM', width: '10%' }, //询价编号
      { component: 'billTitle', label: 'BASE.CERT_TITLE' } //标题
    ],
    [
      { component: 'billType', label: 'BASE.BILL_TYPE', width: '10%' }, //平台单号
      { component: 'inquiryTypeName', label: 'BASE.INQUIRY_TYPE' }, //询价类别
      { component: 'transforInqXkNo', label: '二次招标单号' } //二次招标单号
    ],
    [
      { component: 'createTime', label: 'BASE.CREATED_TIME', width: '10%' }, //创建时间
      { component: 'publishTime', label: 'BASE.PUBLISH_TIME' } //发布时间
    ],
    [
      { component: 'endDate', label: 'BASE.END_DATE', width: '10%' } //截止时间
    ],
    [
      { component: 'createName', label: 'BASE.CREATED_BY', width: '10%' }, //创建人
      { component: 'publishName', label: 'BASE.PUBLISH_BY' } //发布人
    ],
    [
      { component: 'qouteCount', label: '收到总报价(有效)', width: '10%' } //收到总报价(有效)
    ],
    [
      {
        component: 'qouteVendorCount',
        label: 'BASE.QOUTE_VENDOR_COUNT',
        width: '10%'
      } //收到邀约报价
    ],
    [
      { component: 'status', label: 'BASE.STATUS', width: '10%' }, //状态
      { component: 'arrStatusNameString', label: 'BASE.APPROVAL_STATUS' } //审批状态
    ]
  ],
  59: [
    [
      {
        component: 'erpOrgCode',
        label: 'BASE.PURCHASE_ORG_CODE',
        width: '10%'
      }, //采购组织编码
      { component: 'erpOrgName', label: 'BASE.PURCHASE_ORG_NAME' } //采购组织名称
    ],
    [
      { component: 'pcXkNo', label: 'INQUIRY_TENDER.PC_NUM', width: '10%' } //比价单号
    ],
    [
      { component: 'billTitle', label: 'INQUIRY_TENDER.PC_TITLE', width: '10%' } //比价标题
    ],
    [
      { component: 'billType', label: 'BASE.INQUIRY_TENDER_TYPE', width: '10%' } //询价招标类别
    ],
    [
      { component: 'createTime', label: 'INQUIRY_TENDER.PC_TIME', width: '10%' } //比价时间
    ],
    [
      { component: 'createName', label: 'BASE.PUBLISH_BY', width: '10%' } //发布人
    ],
    [
      { component: 'status', label: 'INQUIRY_TENDER.PC_STATUS', width: '10%' }, //状态
      { component: 'arrStatusNameString', label: 'BASE.APPROVAL_STATUS' } //审批状态
    ],
    [{ component: 'isPrinted', label: 'BASE.PRINT_STATUS', width: '10%' }],
    [
      { component: 'priceOrderFlag', label: 'BASE.PRICING', width: '10%' } //核价
    ]
  ],
  87: [
    [{ component: 'batch', width: '3%', align: 'center', disabled: true }],
    [
      {
        component: 'innerVendorCode',
        label: 'BASE.INNER_VENDOR_CODE',
        width: '25%'
      },
      { component: 'innerVendorName', label: 'BASE.INNER_VENDOR_NAME' }
    ],
    [
      { component: 'createTime', label: 'BASE.CREATED_DATE', width: '10%' },
      { component: 'createName', label: 'BASE.CREATED_BY' }
    ],
    [
      { component: 'applyStatus', label: 'BASE.APPLY_STATUS', width: '10%' },
      { component: 'inviteStatus', label: 'BASE.INVITE_STATUS_NAME' },
      { component: 'inviteName', label: 'BASE.INVITE_BY' },
      { component: 'returnDesc', notDisplayLabel: 'BASE.RETURN_REASON' }
    ],
    [
      {
        component: 'certificatesStatus',
        label: 'BASE.FILE_LIST_STATUS',
        width: '10%'
      },
      {
        component: 'certificateAuditFinishTime',
        label: 'QUALIFICATION.QUA_AUDIT_TIME'
      },
      {
        component: 'certificateFileCount',
        label: 'QUALIFICATION.QUAL_DOC_RECORD'
      }
    ],
    [
      {
        component: 'quoteTotalCount',
        label: 'BASE.QUOTATION_RECORD',
        width: '10%'
      },
      { component: 'sampleTotalCount', label: 'BASE.SAMPLE_RECORD' }
    ],
    [
      {
        component: 'admissionReportStatus',
        label: 'ACCESS.ASSESS_STATUS',
        width: '10%'
      },
      { component: 'admissionReportTotalCount', label: 'ACCESS.ASSESS_RECORD' }
    ],
    [
      {
        component: 'esignAuthStatus',
        label: 'BASE.E-SIGN_AUTH_STATUS',
        width: '10%'
      },
      { component: 'syncStatus', label: 'BASE.SYNC_STATUS' },
      { component: 'vendorStatus', label: 'BASE.ACTIVE_STATUS' }
    ],
    [
      {
        component: 'actions',
        label: 'BASE.ACTIONS',
        width: '8%',
        disabled: true
      }
    ]
  ],
  19: [
    [
      {
        component: 'sourceOrder',
        label: 'BASE.SOURCE_ORDER_NO',
        disabled: true,
        width: '14%'
      },
      { component: 'reqInnerNo', label: 'BASE.PR_NUM', disabled: true },
      { component: 'prodGraph', label: 'BASE.PRODUCT_DRAW' },
      { component: 'purCompanyName', label: 'PR.PR_COMPANY' },
      { component: 'reqInnerTypeName', label: 'PR.PR_TYPE' },
      { component: 'projectName', label: 'PR.PR_PROJECT' }
    ],
    [
      { component: 'plantName', label: 'BASE.PLANT', width: '8%' },
      { component: 'departmentName', label: 'BASE.PR_DEPT' },
      { component: 'reqName', label: 'BASE.PR_BY', disabled: true },
      { component: 'noticeEmpNames', label: 'BASE.COLLABORATOR' }
    ],
    [
      {
        component: 'productCode',
        label: 'BASE.ITEM_NUM',
        disabled: true,
        width: '10%'
      },
      { component: 'productName', label: 'BASE.ITEM_NAME', disabled: true },
      { component: 'productScale', label: 'BASE.ITEM_DESC', disabled: true },
      { component: 'vmiType', label: 'BASE.IS_VMI' },
      { component: 'isFreebie', label: 'BASE.IS_FREEBIE' }
    ],
    [
      {
        component: 'poLineExtendFields',
        label: 'BASE.EXTENDED_FIELD',
        width: '8%'
      }
    ],
    [
      {
        component: 'reqDate',
        label: 'BASE.PR_DATE',
        disabled: true,
        width: '7%'
      },
      { component: 'reqUnitName', label: 'PR.PR_UNIT', disabled: true },
      { component: 'demandDate', label: 'PR.DEMAND_DATE', disabled: true },
      { component: 'file', label: 'BASE.ATTACHMENT' }
    ],
    [
      { component: 'reqBrandName', label: 'BASE.BRAND', width: '8%' },
      { component: 'manufacturerProdCode', label: 'BASE.MFR_PROD_CODE' },
      { component: 'purpose', label: 'CUSTOMS.USE' },
      { component: 'platformExtendN01', label: '自定义字段1' },
      { component: 'platformExtendN02', label: '自定义字段2' },
      { component: 'platformExtendN03', label: '自定义字段3' },
      { component: 'platformExtendN04', label: '自定义字段4' },
      { component: 'platformExtendN05', label: '自定义字段5' },
      { component: 'platformExtendN06', label: '自定义字段6' }
    ],
    [
      {
        component: 'reqQty',
        label: 'PR.PR_COUNT',
        disabled: true,
        width: '10%'
      },
      {
        component: 'allocationCount',
        label: 'PR.QUANTITY_ALLOCATED',
        disabled: true
      },
      {
        component: 'innerVendorNameList',
        label: 'BASE.SUPPLIER',
        disabled: true
      },
      { component: 'queryOrg', label: 'BASE.PURCHASE_ORG' }
    ],
    [
      {
        component: 'approvalProdVendorCount',
        label: 'BASE.VALID_PRICING_COUNT',
        width: '10%'
      },
      { component: 'erpPurchaseQty', label: 'PR.ERP_PURCHASE_QTY' },
      { component: 'erpPurchaseValuationQty', label: 'PR.ERP_PURCHASE_VAL_QTY' }
    ],
    [
      {
        component: 'productCategoryTypeName',
        label: 'BASE.MATERIAL_CATEGORY',
        disabled: true,
        width: '8%'
      },
      {
        component: 'productCategoryName',
        label: 'BASE.CATEGORY_NAME',
        disabled: true
      },
      {
        component: 'purchaseStrategy',
        label: 'BASE.PURCHASE_STRATEGY',
        disabled: true
      },
      {
        component: 'buyerEmpName',
        label: 'BASE.RESPONSE_PURCHASE',
        disabled: true
      }
    ],
    [
      {
        component: 'status',
        label: 'BASE.STATUS',
        disabled: true,
        width: '6%'
      }, //状态
      { component: 'poXkNos', label: 'PR.RELATED_PURCHASE', disabled: true }, //关联采购
      { component: 'targetPoXkNos', label: 'PR.RELATED_INQUIRY' }, //关联询价
      { component: 'WBS', label: 'WBS' } //wbs
    ]
  ]
};

export const DETAIL_FIELD_CONFIG: any = {
  10: [
    [
      {
        component: 'poLineNoShow',
        label: 'BASE.LINE_NO',
        width: '5%',
        align: 'center',
        disabled: true
      },
      { component: 'isVmi', notDisplayLabel: '是否VMI', align: 'center' },
      {
        component: 'urgentMaterialFlag',
        notDisplayLabel: '是否急料',
        align: 'center'
      }
      // { component: 'mroSignLine', notDisplayLabel: '无货', align: 'center' }
    ],
    [
      {
        component: 'productCode',
        label: 'BASE.PROD_CODE',
        width: '13%',
        disabled: true
      },
      { component: 'productName', label: 'BASE.PROD_NAME', disabled: true },
      { component: 'productScale', label: 'BASE.PROD_SCALE', disabled: true },
      { component: 'prodFeature', label: 'BASE.PROD_FEATURE' },
      { component: 'manufacturerProdCode', label: 'BASE.MFR_PROD_CODE' },
      { component: 'brandName', label: 'BASE.BRAND' }
    ],
    [
      {
        component: 'profitCenterName',
        label: 'BASE.RECEIVING_DEPARTMENT',
        width: '10%'
      },
      { component: 'storeName', label: 'DELIVERY.RECEIVE_STORE' },
      { component: 'extendFields', label: 'BASE.EXTENDED_FIELD' }
    ],
    [
      { component: 'expectedDate', label: 'PO.EXPECTED_DATE', width: '8%' },
      { component: 'statusName', label: 'BASE.ROW_STATUS' },
      { component: 'receiveTypeName', label: 'BASE.RECEIVE_TYPE' },
      { component: 'prodErpCategoryName', label: 'BASE.CATEGORY_ERP' },
      { component: 'innerProductCode', label: 'BASE.INNER_PROD_CODE' },
      { component: 'subjectTypeName', label: 'BASE.SUBJECT_TYPE' },
      { component: 'isFreebie', label: 'BASE.IS_FREEBIE' },
      { component: 'warrantyPeriod', label: '保修期（天）' },
      { component: 'sysListBody', label: 'BASE.APP_NAME' }
    ],
    [
      {
        component: 'purchaseQty',
        label: 'BASE.PURCHASE_QTY',
        width: '8%',
        align: 'right'
      },
      {
        component: 'purchaseUnitName',
        label: 'BASE.PURCHASE_UNIT',
        align: 'right'
      },
      { component: 'issuedSets', label: 'BASE.ISSUED_SETS', align: 'right' },
      {
        component: 'sourceInnerNoSet',
        label: 'BASE.SOURCE_ORDER_NO',
        align: 'right'
      }
      // { component: 'minOrderQty', label: 'BASE.MIN_ORDER', align: 'right' }
    ],
    [
      {
        component: 'valuationQty',
        label: 'BASE.VALUATION_QTY',
        width: '8%',
        align: 'right'
      },
      {
        component: 'valuationUnitName',
        label: 'BASE.VALUATION_UNIT',
        align: 'right'
      },
      {
        component: 'isContainTax',
        label: 'BASE.IS_TAX_INCLUDED',
        align: 'right'
      },
      { component: 'taxRate', label: 'BASE.TAX_RATE', align: 'right' }
    ],
    [
      {
        component: 'taxPrice',
        label: 'BASE.PRICE',
        width: '10%',
        align: 'right'
      },
      { component: 'taxLineAmount', label: 'BASE.AMOUNT', align: 'right' },
      { component: 'lineAmount', label: 'BASE.UNTAX_AMOUNT', align: 'right' },
      { component: 'tax', label: 'BASE.TAX', align: 'right' },
      {
        component: 'purchasePriceTypeCode',
        label: 'BASE.PRICE_TYPE',
        align: 'right'
      },
      { component: 'minTaxPrice', label: 'BASE.MIN_PRICE', align: 'right' },
      {
        component: 'lineCostAmount',
        label: 'BASE.EXPENSE_ITEM',
        align: 'right'
      }
    ],
    [
      { component: 'remark', label: 'BASE.REMARK', width: '10%' },
      { component: 'confirmDesc', label: 'BASE.CONFIRM_DESC' },
      { component: 'sourceBillsDtoList', label: 'BASE.PR_SOURCE' },
      { component: 'proposerCode', label: 'NOTIFICATION.APPLY_BY' },
      { component: 'itemsCustomField', label: 'BASE.ITEMS_CUSTOM_FIELD' },
      { component: 'stagesCode', label: '分期付款编码' },
      { component: 'stagesDesc', label: '分期付款说明' }
    ],
    [
      { component: 'attachCount', label: 'BASE.ATTACHMENT', width: '8%' },
      { component: 'validFlag', label: 'BASE.FAILED_OR_NOT' },
      { component: 'cpcStatus', label: 'CUSTOMS.CUSTOMS_INFO' },
      { component: 'afterSaleStatus', label: 'BASE.AFTER_SALE_STATUS' }
    ],
    [
      {
        component: 'costCenterName',
        label: 'BASE.COST_CENTER_NAME',
        width: '10%'
      },
      { component: 'wbsProjectName', label: 'PR.PR_PROJECT' },
      { component: 'wbsName', label: 'WBS' },
      { component: 'paymentSubjectName', label: 'BASE.LEDGER_COURSE' },
      { component: 'budgetCodeName', label: 'BASE.BUDGET_CODE' }
    ],
    [
      { component: 'drawerStatus', label: 'PR.REQU_INFO', width: '10%' },
      { component: 'matchProduct', disabled: true },
      { component: 'delete', disabled: true }
    ]
  ],
  26: [
    [
      { component: 'productCode', width: '15%', label: 'BASE.PROD_CODE' },
      { component: 'productName', label: 'BASE.PROD_NAME' },
      { component: 'productScale', label: 'BASE.PROD_SCALE' }
    ],
    [{ component: 'extendFields', width: '10%', label: 'BASE.EXTENDED_FIELD' }],
    [
      { component: 'poErpNo', width: '10%', label: 'BASE.PO_NUM' },
      { component: 'poLineNo', label: 'BASE.PO_LINE' },
      { component: 'addressInfo', label: 'BASE.DELIVERY_ADDRESS' },
      { component: 'poDeliveryStatus', label: 'BASE.DELIVERY_STATUS' }
    ],
    [
      {
        component: 'erpPurchaseDate',
        width: '10%',
        label: 'BASE.PURCHASE_DATE'
      },
      { component: 'buyerName', label: 'BASE.BUYER' }
    ],
    [
      { component: 'orderStatus', width: '10%', label: 'BASE.ORDER_STATUS' },
      { component: 'vExpectedDate', label: 'BASE.EXPECTED_DATE' }
    ],
    [
      {
        component: 'totalUnDeliveryQty',
        width: '10%',
        label: 'DELIVERY.PENDING_QTY'
      }
    ],
    [
      {
        component: 'noticeExpectedDate',
        width: '10%',
        label: 'DELIVERY.APPLY_EXPECTED_DATE'
      }
    ],
    [{ component: 'allNoticeQty', width: '10%', label: 'DELIVERY.APPLY_QTY' }],
    [
      { component: 'confirmStatus', width: '10%', label: 'BASE.AUDIT' },
      { component: 'remark', label: 'BASE.REMARK' }
    ],
    [
      {
        component: 'actions',
        label: 'BASE.ACTIONS',
        width: '5%',
        disabled: true
      }
    ]
  ],
  59: [
    {
      component: 'innerVendorName',
      label: 'BASE.INNER_VENDOR_NAME',
      disabled: true
    },
    { component: 'vendorNewFlagShow', label: 'BASE.SUPPLIER_TYPE' },
    { component: 'payWayName', label: 'BASE.PAY_WAY_NAME' },
    { component: 'invoiceType', label: 'BASE.INVOICE_TYPE' },
    { component: 'relationList', label: '询价需求' },
    {
      component: 'inquiryCompanyName',
      label: 'INQUIRY_TENDER.REQUIRE_COMPANY'
    },
    { component: 'wbs', label: 'WBS' },
    { component: 'wbsProject', label: 'PR.PR_PROJECT' },
    { component: 'kpi', label: 'BASE.PERFORMANCE_GRADE' },
    { component: 'kpi2', label: 'BASE.PLATFORM_REVIEWS' },
    { component: 'thresholdEndQty', label: 'BASE.QUOTE_QTY' },
    { component: 'pricingQuantity', label: 'BASE.VALUATION_QTY' },
    { component: 'description', label: '报价相关说明' },
    { component: 'expectedDate', label: 'STATISTICS.STANDARD_DELIVERY_DATE' },
    { component: 'payMethodCode', label: 'BASE.PAY_WAY_MODE' },
    { component: 'firstRoundPrice', label: '第一轮报价' },
    { component: 'firstQuotePriceInOneOrder', label: 'BASE.FIRST_PRICE' },
    { component: 'negotiatePriceRate', label: '议价降价率' },
    { component: 'historyMinPrice', label: '历史低价' },
    { component: 'estimatePrice', label: 'PR.EST_PRICE' },
    { component: 'quotePrice', label: 'BASE.QUOTE_PRICE', disabled: true },
    { component: 'quoteCurrencyName', label: 'BASE.QUOTATION_CURRENCY' },
    { component: 'priceContainTaxFlag', label: '含税否/税率' },
    { component: 'quoteAmountTotal', label: '报价金额' },
    { component: 'warrantyPeriod', label: '保修期（天）' },
    { component: 'quoteTmp', label: '报价模板' },
    { component: 'minPrcPrice', label: '最低核价单价' },
    { component: 'minPurchasePrice', label: '最低采购单价' },
    { component: 'baseCurrencyPrice', label: 'BASE.STANDARD_CION_PRICE' },
    { component: 'baseCurrencyCode', label: 'BASE.STANDARD_CION_CURRENCY' },
    { component: 'quoteBaseAmountTotal', label: '本位币金额' },
    { component: 'lastPrcPrice', label: 'BASE.LATEST_PRICING_PRICE' },
    { component: 'pricingTime', label: 'BASE.LATEST_PRICING_DATE' },
    { component: 'prcDownPriceRate', label: 'BASE.PRICE_CUT_RATE' },
    { component: 'poWaitDeliveryQty', label: 'SCHEDULE.UN_DELIVERIED_QTY' },
    { component: 'latestPurchasePrice', label: 'BASE.LATEST_PURCHASE_PRICE' },
    { component: 'latestPurchaseDate', label: 'BASE.LATEST_PURCHASE_DATE' },
    { component: 'downPriceRate', label: 'BASE.PRICE_CUT_RATE' },
    { component: 'promiseDeliDays', label: 'BASE.PROMISED_DATE' },
    { component: 'minPurchaseQty', label: 'BASE.MIN_PURCHASE_QTY' },
    { component: 'modelFee', label: 'BASE.MOULD_COST' },
    { component: 'brandName', label: 'BASE.BRAND' },
    { component: 'manufacturerProdCode', label: 'BASE.MFR_PROD_CODE' },
    { component: 'minPackage', label: 'BASE.MINPACKAGE' },
    { component: 'fileMd5s', label: 'BASE.QUOTE_ATTACHMENT' },
    { component: 'quoteTmpCustomField', label: '报价模板自定义字段' },
    { component: 'itemsCustomField', label: 'BASE.ITEMS_CUSTOM_FIELD' },
    { component: 'costCustomField', label: '报价成本项目' },
    { component: 'prodCustomField', label: '物料自定义字段' }
  ],
  //移动端核价单
  '23_mobile': [
    { component: 'productCode', label: 'BASE.ITEM_NUM', disabled: true },
    { component: 'productName', label: 'BASE.ITEM_NAME' },
    { component: 'productScale', label: 'BASE.ITEM_DESC' },
    { component: 'startQty', label: 'PR.STARTING_QUANTITY' },
    { component: 'endQty', label: 'PR.CUT_OFF_QUANTITY' },
    { component: 'minPurchaseQty', label: 'BASE.MIN_PURCHASE_QTY' },
    { component: 'taxName', label: 'BASE.TAX_CODE', disabled: true },
    { component: 'taxRateShow', label: 'BASE.TAX_RATE' },
    { component: 'purchaseRate', label: 'FIELD_SETTING.PUR_PROP' },
    { component: 'taxPrice', label: 'BASE.TAX_PRICE', disabled: true },
    { component: 'price', label: 'BASE.UNTAX_PRICE' },
    { component: 'unitName', label: 'BASE.VALUATION_UNIT' },
    { component: 'lastPrice', label: 'BASE.RECENT_PRICE_UNIT_PRICE' },
    { component: 'minLastPrice', label: 'BASE.MINIMUM_PRICE_UNIT_PRICE' },
    { component: 'priceCutRate', label: 'BASE.PRICE_CUT_RATE' },
    { component: 'quotePrice', label: 'BASE.QUOTE_PRICE' },
    { component: 'effectiveDate', label: 'BASE.EFFECTIVE_TIME' },
    { component: 'invalidDate', label: 'BASE.EXPIRATION_TIME' },
    { component: 'transportTypeName', label: 'BASE.LOGISTICS_CODE' },
    { component: 'brandName', label: 'BASE.BRAND' },
    { component: 'promiseDeliDays', label: 'BASE.PROMISED_DATE' },
    { component: 'minPackage', label: 'BASE.MINPACKAGE' },
    { component: 'manufacturerProdCode', label: 'BASE.MFR_PROD_CODE' },
    { component: 'manufacturerName', label: 'BASE.MANUFACTURER' },
    { component: 'remark', label: 'BASE.REMARK' },
    { component: 'priceCompareDesc', label: 'BASE.COMPARE_DESC' },
    { component: 'prodfieldSet', label: 'BASE.ITEMS_CUSTOM_FIELD' },
    { component: 'minQuotePrice', label: 'INQUIRY.MIN_QUOTE_PRICE', hide: true }
  ],
  //移动端比价单
  '59_mobile': [
    {
      component: 'innerVendorName',
      label: 'BASE.INNER_VENDOR_NAME',
      disabled: true
    },
    // { component: 'vendorNewFlagShow', label: 'BASE.SUPPLIER_TYPE' },
    // { component: 'payWayName', label: 'BASE.PAY_WAY_NAME' },
    // { component: 'invoiceType', label: 'BASE.INVOICE_TYPE' },
    // { component: 'relationList', label: '询价需求' },
    {
      component: 'inquiryCompanyName',
      label: 'INQUIRY_TENDER.REQUIRE_COMPANY'
    },
    { component: 'wbs', label: 'WBS' },
    { component: 'wbsProject', label: 'PR.PR_PROJECT' },
    { component: 'thresholdEndQty', label: 'BASE.QUOTE_QTY' },
    // { component: 'pricingQuantity', label: 'BASE.VALUATION_QTY' },
    { component: 'description', label: '报价相关说明' },
    // { component: 'expectedDate', label: 'STATISTICS.STANDARD_DELIVERY_DATE' },
    { component: 'payMethodCode', label: 'BASE.PAY_WAY_MODE' },
    { component: 'firstRoundPrice', label: '第一轮报价' },
    { component: 'firstQuotePriceInOneOrder', label: 'BASE.FIRST_PRICE' },
    // { component: 'negotiatePriceRate', label: '议价降价率' },
    // { component: 'historyMinPrice', label: '历史低价' },
    // { component: 'estimatePrice', label: 'PR.EST_PRICE' },
    { component: 'quotePrice', label: 'BASE.QUOTE_PRICE', disabled: true },
    // { component: 'quoteCurrencyName', label: 'BASE.QUOTATION_CURRENCY' },
    { component: 'priceContainTaxFlag', label: '含税否/税率' },
    { component: 'unTaxPrice', label: 'BASE.UNTAX_PRICE' },
    { component: 'quoteAmountTotal', label: '报价金额' },
    // { component: 'warrantyPeriod', label: '保修期（天）' },
    // { component: 'minPrcPrice', label: '最低核价单价' },
    // { component: 'minPurchasePrice', label: '最低采购单价' },
    // { component: 'baseCurrencyPrice', label: 'BASE.STANDARD_CION_PRICE' },
    // { component: 'baseCurrencyCode', label: 'BASE.STANDARD_CION_CURRENCY' },
    // { component: 'quoteBaseAmountTotal', label: '本位币金额' },
    { component: 'lastPrcPrice', label: 'BASE.LATEST_PRICING_PRICE' },
    { component: 'pricingTime', label: 'BASE.LATEST_PRICING_DATE' },
    { component: 'prcDownPriceRate', label: 'BASE.PRICE_CUT_RATE' },
    // { component: 'poWaitDeliveryQty', label: 'SCHEDULE.UN_DELIVERIED_QTY' },
    { component: 'latestPurchasePrice', label: 'BASE.LATEST_PURCHASE_PRICE' },
    { component: 'latestPurchaseDate', label: 'BASE.LATEST_PURCHASE_DATE' },
    { component: 'downPriceRate', label: 'BASE.PRICE_CUT_RATE' },
    { component: 'promiseDeliDays', label: 'BASE.PROMISED_DATE' },
    { component: 'minPurchaseQty', label: 'BASE.MIN_PURCHASE_QTY' },
    { component: 'modelFee', label: 'BASE.MOULD_COST' },
    { component: 'brandName', label: 'BASE.BRAND' },
    { component: 'manufacturerProdCode', label: 'BASE.MFR_PROD_CODE' },
    { component: 'minPackage', label: 'BASE.MINPACKAGE' },
    { component: 'itemsCustomField', label: 'BASE.ITEMS_CUSTOM_FIELD' },
    { component: 'extendFields', label: 'BASE.EXTENDED_FIELD', hide: true }, //采购说明
    {
      component: 'offerValidityDateStart',
      label: 'INQUIRY.QUOTE_EFFECT_DATE',
      hide: true
    },
    {
      component: 'offerValidityDate',
      label: 'INQUIRY.QUOTE_EXPIRA_DATE',
      hide: true
    }
  ]
};
